import { Flex, theme } from 'modules/ui';
import { NavigationAndActionDeleteInput } from 'modules/ui/icons';
import styled, { css } from 'styled-components';

const textStyle = css`
  color: ${({theme}) => theme.colors.primaryK9};
  font-weight: ${theme.fontWeight.thin};
  font-size: var(--main-font-size);
  line-height: var(--main-line-height);
  word-spacing: var(--word-spacing);
`;

export const StyledInput = styled.input<{
  hasIcon?: boolean;
  hasError?: boolean;
  disabled?: boolean;
  readOnly?: boolean;
  prefix?: string;
  hasPrefix?: boolean;
}>`
  width: 100%;
  border: 1px solid ${({theme}) => theme.colors.primaryK4};
  padding: 0.5rem;
  transition: all 0.15s linear;

  ${textStyle}

  &::placeholder {
    color: ${({theme}) => theme.colors.primaryK9};
  }

  &:focus {
    outline: none;
  }

  &:hover,
  &:active,
  &:focus {
    border: 1px solid ${({theme}) => theme.colors.primaryK10};
  }

  ${(props) => (props.hasIcon ? 'padding-right: 3rem;' : '')};

  ${(props) =>
    props.disabled || props.readOnly
      ? `
          &, &:hover, &:active, &:focus {
            color: ${
              props.disabled ? props.theme.colors.primaryK3 : props.theme.colors.primaryK9
            };
            background-color: ${props.theme.colors.primaryK1};
            border: 1px solid ${props.theme.colors.primaryK3};
          }
          &::placeholder {
            color: ${props.theme.colors.primaryK9};
          }`
      : ''};

  ${(props) =>
    props.hasError
      ? `
      &, &:hover, &:active, &:focus { 
        border: 2px solid ${props.theme.colors.primaryR5}; 
      }`
      : ''};

  ${(props) =>
    props.hasPrefix && props.prefix
      ? `
         padding-left: calc(var(--main-font-size) + 45px);`
      : ''};
`;

export const IconContainer = styled(Flex)<{
  disabled?: boolean;
  readOnly?: boolean;
  hasIcon?: boolean;
}>`
  user-select: none;
  cursor: pointer;
  height: 1.5rem;
  justify-content: center;

  ${(props) =>
    props.disabled || props.readOnly
      ? `
        pointer-events: none;
        svg path {
          fill: ${props.theme.colors.primaryK3};
        }`
      : '&:hover { opacity: 0.9 }'}
`;

export const InputError = styled.div<{
  hasError?: boolean;
}>`
  width: 100%;
  & > p {
    background-color: ${({theme}) => theme.colors.primaryR5};
    color: ${({theme}) => theme.colors.primaryW};
    padding: 0.563rem 0.625rem;
    user-select: none;

    font-weight: ${theme.fontWeight.thin};
    font-size: var(--main-font-size);
    line-height: var(--main-line-height);
    margin: 0;
  }
  opacity: 0;
  visibility: hidden;
  height: 0;
  transition: all 0.15s linear;

  ${(props) =>
    props.hasError ? `opacity:1; visibility: visible; height: 100%;` : ''};
`;

export const InputWrapper = styled(Flex)`
  width: 100%;
`;

export const IconsWrapper = styled(Flex)`
  position: relative;
  margin-right: 0.5rem;
  top: -1.3rem;
  height: 0;

  flex-direction: row;
  align-self: flex-end;
  align-items: center;
  gap: 0.3rem;
`;

export const StyledClearIcon = styled(NavigationAndActionDeleteInput)`
  width: 0.938rem;
  height: 0.938rem;

  path {
    fill: ${({theme}) => theme.colors.primaryK11};
  }
`;

export const Prefix = styled.div`
  ${textStyle}
  position: absolute;
  padding-left: 0.5rem;
  pointer-events: none;
`;

export const Sufix = styled.div`
  font-size: 1.125rem;
  font-weight: ${theme.fontWeight.bold};
`;
